import { arrayMove } from "@dnd-kit/sortable";

export interface OrderedItem {
  id: string;
  position: number;
}

// Flat reorder: move activeId to overId's slot, renumber 1..N, return changed subset.
export const reorderFlat = <T extends OrderedItem>(
  items: T[],
  activeId: string,
  overId: string
): { next: T[]; changed: T[] } => {
  const oldIndex = items.findIndex((i) => i.id === activeId);
  const newIndex = items.findIndex((i) => i.id === overId);
  if (oldIndex < 0 || newIndex < 0) return { next: items, changed: [] };
  const next = arrayMove(items, oldIndex, newIndex).map((i, idx) => ({
    ...i,
    position: idx + 1,
  }));
  const changed = next.filter(
    (i) => i.position !== items.find((p) => p.id === i.id)?.position
  );
  return { next, changed };
};
